import { Component, OnInit, Input } from '@angular/core';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import {
	PrintableReport,
	SlideWidgetDataConfiguration
} from '../../../analytics-core/interfaces/printable-reports.interface';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import {
	EVENT_EMITTERS,
	OPTIONS,
	PRINTABLE_ACCESS_KEYS,
	PRINTABLE_OVERVIEW_ACCESS_KEYS,
	PRINTABLE_TOOLTIP,
	PRISTINE_PERMISSIONS,
	GAM_PRODUCT_SEPERATED_Rs
} from '../../../analytics/constants/analytics.constants';
import { PERMISSION } from '../../../analytics-core/interfaces/permission.interface';
import { StorageSessionService } from '../../../../core/storage/services/storage.session.service';
import { KEYS } from '../../../../core/service/constants/service.constants';
import { AnalyticsCoreURLService } from '../../../analytics-core/services/analytics-core.url.service';
import * as moment from 'moment';
import * as _ from 'underscore';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { Router } from '@angular/router';
import { AnalyticsMixpanelService } from '../../../analytics/services/analytics.mixpanel.service';

@Component({
	selector: 'app-printable-report',
	templateUrl: './printable-report.component.html',
	styleUrls: ['./printable-report.component.css']
})
export class PrintableReportComponent implements OnInit {
	public printableReportConfiguration: PrintableReport;
	public slideWidgetData: string[] = [];
	public printableModalConfig: SlideWidgetDataConfiguration;
	public pristinePrintableModalConfig: SlideWidgetDataConfiguration;
	public sem_btnEnabled: boolean = false;
	public strategyName: string;
	public hasPrintableAccess: boolean;
	public printableProductName: string;
	public printableSubscription: any;
	public colorPalette: ColorPalette;

	public startDate: any;
	public endDate: any;
	public productCampaigns: any;
	public accessibleCampaigns: any;
	public productCampaignsCount: any;
	public toolTipMsg: string = null;
	public overviewToolTipMsg: string = null;
	public version: any;
	public directoryName: any;
	public disableToolTip: boolean;
	public maxCampaignsAllowed: number;
	public hasCustomizeCampaignLimit: boolean;
	public productCampaignsActiveCount: any = 0;
	public overviewPrintableProductsTemp: any = {};
	public hasActiveCampaign: boolean = false;
	public overviewPrintableProducts = {
		advertisers: {},
		campaigns: {}
	};
	public isR13: boolean = false;
	public standaloneGAMPermissionCheck: object = { permission: { flags: ['hasStandaloneGAM'] } };
	public overviewPrintablePermission = {
		display: 'hasDisplayPrintableAccess',
		geofence: 'hasGeofencePrintableAccess',
		geovideo: 'hasGeovideoPrintableAccess',
		preroll: 'hasPrerollPrintableAccess',
		sem: 'hasSEMPrintableAccess',
		ctv: 'hasCtvPrintableAccess',
		social: 'hasSocialPrintableAccess',
		radio: 'hasStreaminAudioPrintableAccess',
		email: 'hasEmailPrintableAccess',
		triton_radio: 'hasTritonPrintableAccess',
		responsive_display: 'hasResponsiveDisplayPrintableAccess',
		gam: 'hasGAMPrintableAccess',
		dooh: 'hasDOOHPrintableAccess'
	};
	public overviewReport: boolean = false;
	public OverviewReportPermission: object = { permission: { flags: ['hasOverviewPrintableAccess'] } };
	@Input('permission-key') permissionKey: string;
	@Input() overviewprintablereport: string = '';

	constructor(
		protected modalService: ModalService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected storageSessionService: StorageSessionService,
		protected analyticsCoreURLService: AnalyticsCoreURLService,
		protected router: Router,
		protected analyticsMixpanelService: AnalyticsMixpanelService
	) {
		const permissions = this.analyticsDataModel.setupData.userPermissions;
		this.overviewReport = this.analyticsDataModel.checkComponentForPermission(this.OverviewReportPermission);
		this.hasCustomizeCampaignLimit = !UtilityService.isUndefinedOrNull(
			permissions[PERMISSION[PERMISSION.customizeCampaignLimit]]
		)
			? permissions[PERMISSION[PERMISSION.customizeCampaignLimit]]
			: false;
		this.maxCampaignsAllowed = this.hasCustomizeCampaignLimit
			? OPTIONS.CAMPAIGNS.MAXIMUN_CAMPAIGNS
			: OPTIONS.CAMPAIGNS.DEFAULT_CAMPAIGNS;
		PRINTABLE_TOOLTIP.DISABLED = this.hasCustomizeCampaignLimit
			? 'Reports are available for up to 10 Advertisers or ' +
			  OPTIONS.CAMPAIGNS.MAXIMUN_CAMPAIGNS +
			  ' Campaigns <br/> and date ranges up to 1 year.'
			: PRINTABLE_TOOLTIP.DISABLED;
		const urls = this.router.url.split('/');
		const url: string = urls[urls.length - 1].split('?')[0];
		this.printableProductName = urls[urls.length - 1];
		this.setUpPrintableReportData(url);
		this.version = this.analyticsDataModel.config.version.toLowerCase();
		this.directoryName = this.analyticsDataModel.config.directoryName;
		this.printableSubscription = EmitterService.get(EVENT_EMITTERS.PRINTABLE_PERMISSIONS).subscribe((response: any) => {
			if (this.hasPrintableAccess || this.overviewReport) {
				this.accessibleCampaigns = this.findAllSelectedCampaignByPermissions(response[1], url, false);
				const campaignCountWithSupplementalObj =
					this.accessibleCampaigns.length <= this.maxCampaignsAllowed ? this.accessibleCampaigns.length : 0;
				if (this.checkDateRange()) {
					this.sem_btnEnabled = campaignCountWithSupplementalObj > 0;
					this.disableToolTip = !!(this.version === 'r6' && campaignCountWithSupplementalObj);
					this.toolTipMsg = campaignCountWithSupplementalObj
						? this.version === 'r9'
							? PRINTABLE_TOOLTIP.R9_ENABLED
							: PRINTABLE_TOOLTIP.ENABLED
						: PRINTABLE_TOOLTIP.DISABLED;
					this.overviewToolTipMsg =
						campaignCountWithSupplementalObj > 0
							? PRINTABLE_TOOLTIP.ENABLED_OVERVIEW_TOOLTIP
							: PRINTABLE_TOOLTIP.DISABLED;
				} else {
					this.disableToolTip = false;
					this.sem_btnEnabled = false;
					this.toolTipMsg = PRINTABLE_TOOLTIP.DISABLED;
				}
				this.productCampaigns = response[1];
				this.productCampaignsCount = campaignCountWithSupplementalObj;
			}
		});
		if (this.analyticsDataModel.printableReport) {
			if (this.hasPrintableAccess) {
				this.accessibleCampaigns = this.findAllSelectedCampaignByPermissions(
					this.analyticsDataModel.printableReport[1],
					url,
					false
				);
				const campaignCountWithSupplementalObj =
					this.accessibleCampaigns.length <= this.maxCampaignsAllowed ? this.accessibleCampaigns.length : 0;
				if (this.checkDateRange()) {
					this.sem_btnEnabled = campaignCountWithSupplementalObj > 0;
					this.disableToolTip = !!(this.version === 'r6' && campaignCountWithSupplementalObj);
					this.toolTipMsg = campaignCountWithSupplementalObj
						? this.version === 'r9'
							? PRINTABLE_TOOLTIP.R9_ENABLED
							: PRINTABLE_TOOLTIP.ENABLED
						: PRINTABLE_TOOLTIP.DISABLED;
				} else {
					this.disableToolTip = false;
					this.sem_btnEnabled = false;
					this.toolTipMsg = PRINTABLE_TOOLTIP.DISABLED;
				}
				this.productCampaigns = this.analyticsDataModel.printableReport[1];
				this.productCampaignsCount = campaignCountWithSupplementalObj;
			}
		}
		EmitterService.get(EVENT_EMITTERS.HAS_PRODUCT_PRINTABLE_ACCESS).emit({
			permissions: this.hasPrintableAccess,
			activeCampaigns: this.accessibleCampaigns
		});
	}

	ngOnInit() {
		this.isR13 = this.analyticsDataModel.config.version === 'R13' ? true : false;
		if (this.overviewprintablereport == 'overview') {
			this.setUpPrintableReportData('overview');
		}
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.overviewToolTipMsg = PRINTABLE_TOOLTIP.ENABLED_OVERVIEW_TOOLTIP;
	}

	ngOnDestroy() {
		if (this.printableSubscription) {
			this.printableSubscription.unsubscribe();
		}
		this.accessibleCampaigns = [];
	}
	showWidgetModal() {
		if ((this.hasPrintableAccess || this.overviewReport) && this.sem_btnEnabled) {
			this.resetPrintableModalConfig();

			let product;
			this.analyticsDataModel.config.products.forEach((item) => {
				if (item.productURL === this.analyticsDataModel.getCurrentPath()) {
					product = item;
				}
			});

			let event_name =
				this.analyticsDataModel.getCurrentPath() === 'overview' || this.overviewprintablereport == 'overview'
					? 'Analytics / Bulk PDF Printable Generation'
					: 'Analytics / ' + product.productName + ' PDF Printable Generation';
			this.productCampaignsActiveCount = this.analyticsMixpanelService.productSelectedActiveCampaign(
				this.overviewprintablereport
			);
			this.analyticsMixpanelService.mixpanelBulkDownloadData(
				event_name,
				this.productCampaignsActiveCount,
				this.overviewprintablereport
			);

			if (
				this.productCampaignsCount > 1 &&
				this.analyticsDataModel.config.products.filter((item) => {
					if (item.productURL === this.analyticsDataModel.getCurrentPath()) {
						return item;
					}
				})[0].printableModalPopUp
			) {
				this.modalService.open('productsModal');
			} else {
				if (this.hasActiveCampaign) {
					this.navigateToPlatform();
				}
			}
		}
	}

	resetPrintableModalConfig() {
		for (const key in this.printableModalConfig) {
			if (this.printableModalConfig.hasOwnProperty(key)) {
				this.printableModalConfig[key].value = this.pristinePrintableModalConfig[key].value;
			}
		}
	}

	navigateToPlatform() {
		const data = this.getDataForNavigation();
		this.openWindowWithPost(data);
		this.modalService.close('productsModal');
		this.resetPrintableModalConfig();
	}

	getDataForNavigation() {
		const urls = this.router.url.split('/');
		const url: string = urls[urls.length - 1].split('?')[0];
		const authToken = this.storageSessionService.getToken(KEYS.STORAGE_TOKEN_ID)[KEYS.COOKIE_TOKEN_ID];
		const domain = this.analyticsCoreURLService.domainName;
		const campaigns: any[] = this.findAllSelectedCampaignByPermissions(this.accessibleCampaigns, url, true, true);
		const advertisers: any[] = this.activeAdvertiserFilter(this.analyticsDataModel.selectedAdvertisers, campaigns);
		const advertiserIds = _.pluck(advertisers, 'id');
		const campaignIds = _.pluck(campaigns, 'campaignId');
		const startDate = moment(this.analyticsDataModel.startDate).format('YYYY-MM-DD');
		const endDate = moment(this.analyticsDataModel.endDate).format('YYYY-MM-DD');
		const product = this.analyticsDataModel.config.products.filter((item) => {
			return item.productURL.toUpperCase() == url.toUpperCase();
		});
		const slideConfig = this.buildSlideConfigObject();
		this.setUpPrintableReportData(url);
		const data = {
			auth_token: authToken,
			domain: domain,
			start_date: startDate,
			end_date: endDate,
			printable_strategy_name: this.strategyName,
			advertiser_ids: advertiserIds,
			campaign_ids: campaignIds,
			slide_config: JSON.stringify(slideConfig),
			action: '',
			version: 'V2',
			analytics_version: this.analyticsDataModel.config.version.toLocaleLowerCase(),
			landing_page: 'slide_deck_v2',
			product_name: this.overviewprintablereport ? 'Overview' : product[0].productName,
			overview_download_products: encodeURIComponent(JSON.stringify(this.overviewPrintableProducts))
		};
		return data;
	}

	openWindowWithPost(data) {
		const form = document.createElement('form');
		form.target = '_blank';
		form.method = 'POST';
		form.action = this.analyticsCoreURLService.serviceURL + '/analytics_module/redirect_to_platform/';
		form.style.display = 'none';

		for (const key in data) {
			const input = document.createElement('input');
			input.type = 'hidden';
			input.name = key;
			input.value = data[key];
			form.appendChild(input);
		}
		document.body.appendChild(form);
		form.submit();
		document.body.removeChild(form);
	}

	setUpPrintableReportData(url: string): void {
		if (url !== 'overview' && this.overviewprintablereport !== 'overview') {
			const productConfig = _.findWhere(this.analyticsDataModel.config.products, { productURL: url });
			this.printableReportConfiguration = !_.isEmpty(productConfig.printableReport)
				? JSON.parse(JSON.stringify(productConfig.printableReport))
				: null;
			this.hasPrintableAccess = this.checkIfUserHasPermission(url);
			const permissions = this.analyticsDataModel.setupData.permissions;
			if (this.printableReportConfiguration && this.printableReportConfiguration.slideWidgetDataConfiguration) {
				const modalConfig = this.printableReportConfiguration.slideWidgetDataConfiguration;
				this.printableModalConfig = this.filterPrintableConfigByPermissions(modalConfig, permissions);
				this.pristinePrintableModalConfig = JSON.parse(JSON.stringify(this.printableModalConfig));
				this.slideWidgetData = _.keys(this.printableModalConfig);
				// to handle specific scenario for R13 wick GAM where display product have to pick the strategy depending on the hasStandAloneGAM permission
				this.strategyName = this.printableReportConfiguration.strategyName;
				if (this.isR13) {
					var r13DisplayStrategyNames: string[] = this.strategyName.split(',').map((item) => item.trim());
					if (r13DisplayStrategyNames.length > 1) {
						if (this.analyticsDataModel.getCurrentPath() === 'display') {
							this.strategyName = !this.analyticsDataModel.checkComponentForPermission(
								this.standaloneGAMPermissionCheck
							)
								? r13DisplayStrategyNames[0]
								: r13DisplayStrategyNames[1];
						}
					}
				}
			}
		} else if (url == 'overview' || this.overviewprintablereport == 'overview') {
			if (url == 'overview') {
				const productConfig = _.findWhere(this.analyticsDataModel.config.products, { productURL: url });
				if (!_.isEmpty(productConfig)) {
					this.printableReportConfiguration = !_.isEmpty(productConfig.printableReport)
						? JSON.parse(JSON.stringify(productConfig.printableReport))
						: null;
				} else {
					this.printableReportConfiguration = null;
				}
			} else {
				const overviewReportConfig = this.analyticsDataModel.config.overviewPrintableReport;
				this.printableReportConfiguration = !_.isEmpty(overviewReportConfig)
					? JSON.parse(JSON.stringify(overviewReportConfig))
					: null;
			}
			if (this.printableReportConfiguration != null) {
				this.hasPrintableAccess = this.checkIfUserHasPermission('overview');
				const permissions = this.analyticsDataModel.setupData.permissions;
				if (this.printableReportConfiguration && this.printableReportConfiguration.slideWidgetDataConfiguration) {
					const modalConfig = this.printableReportConfiguration.slideWidgetDataConfiguration;
					this.printableModalConfig = this.filterPrintableConfigByPermissions(modalConfig, permissions);
					this.pristinePrintableModalConfig = JSON.parse(JSON.stringify(this.printableModalConfig));
					this.slideWidgetData = _.keys(this.printableModalConfig);
					// to handle specific scenario for R13 wick GAM where overview product have to pick the strategy depending on the hasStandAloneGAM permission
					this.strategyName = this.printableReportConfiguration.strategyName;
					if (this.isR13) {
						var r13DisplayStrategyNames: string[] = this.strategyName.split(',').map((item) => item.trim());
						if (r13DisplayStrategyNames.length > 1) {
							this.strategyName = !this.analyticsDataModel.checkComponentForPermission(
								this.standaloneGAMPermissionCheck
							)
								? r13DisplayStrategyNames[0]
								: r13DisplayStrategyNames[1];
						}
					}
				}
			}
		}
	}

	filterPrintableConfigByPermissions(printableModalConfig: SlideWidgetDataConfiguration, permissions = []) {
		for (const key in printableModalConfig) {
			if (printableModalConfig.hasOwnProperty(key)) {
				if (printableModalConfig[key].permissions) {
					const intersection = _.intersection(permissions, printableModalConfig[key].permissions);
					if (intersection.length === 0) {
						delete printableModalConfig[key];
					}
				}
			}
		}
		return printableModalConfig;
	}

	checkDateRange(): boolean {
		this.startDate = moment(this.analyticsDataModel.startDate);
		this.endDate = moment(this.analyticsDataModel.endDate);
		const dateRange = this.endDate ? 1 + this.endDate.diff(this.startDate, 'days') : null;
		return dateRange <= 366;
	}

	checkIfUserHasPermission(url: string): boolean {
		if (this.printableReportConfiguration) {
			if (this.printableReportConfiguration.permission.isGeneric) {
				return true;
			} else {
				const widgetPermissions = this.printableReportConfiguration.permission.flags;
				for (const permission of widgetPermissions) {
					if (_.indexOf(this.analyticsDataModel.setupData.permissions, permission) !== -1) {
						return true;
					}
				}
			}
			return false;
		} else {
			return false;
		}
	}

	private buildSlideConfigObject(): object {
		const slideConfig = {};
		_.each(this.slideWidgetData, (slideDataMetric) => {
			slideConfig[slideDataMetric] = this.printableModalConfig[slideDataMetric].value;
		});
		return slideConfig;
	}

	private findAllSelectedCampaignByPermissions(
		response: any[],
		url: string,
		filterBySelectedCampaign: boolean = true,
		finalCall: boolean = false
	): any[] {
		const printableAccessPermissionKeys: any[] =
			url.toUpperCase() === 'OVERVIEW' || this.overviewprintablereport == 'overview'
				? PRINTABLE_OVERVIEW_ACCESS_KEYS['OVERVIEW']
				: [PRINTABLE_ACCESS_KEYS[url.toUpperCase()]];
		const supplementalPermissions = this.printableReportConfiguration?.supplementalCampaigns?.permissions;
		if (!UtilityService.isUndefinedOrNull(supplementalPermissions)) {
			const permissionsFlags = supplementalPermissions.flags;
			_.each(permissionsFlags, (flag) => {
				printableAccessPermissionKeys.push(PRISTINE_PERMISSIONS[flag]);
			});
		}
		this.overviewPrintableProductsTemp = {};
		this.overviewPrintableProducts = {
			advertisers: {},
			campaigns: {}
		};
		this.hasActiveCampaign = response.some((campaign) => campaign.active || campaign.disabled);
		const R13GamPermission = this.analyticsDataModel.checkOverviewPrintablePermission('hasStandaloneGAM');
		const campaignsByPermissions = response.filter((campaign: any) => {
			// Filter out campaigns that don't have the required data example: has_display_access::1 then keep has_display_access or else remove it.
			campaign.permission = campaign.permission.filter(
				(permission) =>
					campaign.activePermissionsWithData?.includes(permission + '::1') ||
					campaign.permission_impressions?.includes(permission + '::1')
			);
			if (campaign.active || campaign.disabled == 'false') {
				if (
					url.toUpperCase() === 'OVERVIEW' ||
					this.overviewprintablereport == 'overview' ||
					GAM_PRODUCT_SEPERATED_Rs.includes(this.directoryName)
				) {
					for (const product in PRINTABLE_ACCESS_KEYS) {
						const isDOOH = product.toLocaleLowerCase() === 'dooh';
						if (
							(this.isR13 && !R13GamPermission) ||
							!GAM_PRODUCT_SEPERATED_Rs.includes(this.analyticsDataModel.config.directoryName) ||
							(product.toLocaleLowerCase() !== 'display' && product.toLocaleLowerCase() !== 'preroll')
						) {
							campaign.permission.forEach((element) => {
								const validAccessKey = isDOOH
									? element === PRINTABLE_ACCESS_KEYS['DOOH'] || element === PRINTABLE_ACCESS_KEYS['DOOHVideo']
									: element === PRINTABLE_ACCESS_KEYS[product];

								if (validAccessKey) {
									this.overviewPrintableProductsTemp[product.toLowerCase()] == undefined
										? (this.overviewPrintableProductsTemp[product.toLowerCase()] = new Array(campaign))
										: this.overviewPrintableProductsTemp[product.toLowerCase()].push(campaign);
								}
							});
						} else {
							if (!campaign.permission.includes('has_gam_access')) {
								campaign.permission.forEach((element) => {
									if (element == PRINTABLE_ACCESS_KEYS[product]) {
										this.overviewPrintableProductsTemp[product.toLowerCase()] == undefined
											? (this.overviewPrintableProductsTemp[product.toLowerCase()] = new Array(campaign))
											: this.overviewPrintableProductsTemp[product.toLowerCase()].push(campaign);
									}
								});
							}
						}
					}
				}
				return campaign.permission.some(
					(permission) => printableAccessPermissionKeys.includes(permission) && this.hasActiveCampaign
				);
			}
		});

		if (
			url.toUpperCase() === 'OVERVIEW' ||
			this.overviewprintablereport == 'overview' ||
			GAM_PRODUCT_SEPERATED_Rs.includes(this.directoryName)
		) {
			if (
				this.overviewPrintableProductsTemp['geofence'] != undefined ||
				this.overviewPrintableProductsTemp['geovideo'] != undefined
			) {
				var separateGoefenceProduct = false;
				var separateGeovideoProduct = false;
				this.analyticsDataModel.config.products.forEach((item) => {
					if (item.productURL === 'geofence') {
						separateGoefenceProduct = true;
					} else if (item.productURL === 'geovideo') {
						separateGeovideoProduct = true;
					}
				});
				if (!separateGoefenceProduct) {
					if (this.overviewPrintableProductsTemp['display'] == undefined) {
						this.overviewPrintableProductsTemp['display'] = this.overviewPrintableProductsTemp['geofence'];
					} else {
						this.overviewPrintableProductsTemp['geofence']?.forEach((item, i) => {
							this.overviewPrintableProductsTemp['display'].push(this.overviewPrintableProductsTemp['geofence'][i]);
						});
					}
					this.overviewPrintableProductsTemp['display'] = [...new Set(this.overviewPrintableProductsTemp['display'])];
				}
				if (!separateGeovideoProduct) {
					if (this.overviewPrintableProductsTemp['preroll'] == undefined) {
						this.overviewPrintableProductsTemp['preroll'] = this.overviewPrintableProductsTemp['geovideo'];
					} else {
						this.overviewPrintableProductsTemp['geovideo']?.forEach((item, i) => {
							this.overviewPrintableProductsTemp['preroll'].push(this.overviewPrintableProductsTemp['geovideo'][i]);
						});
					}
					this.overviewPrintableProductsTemp['preroll'] = [...new Set(this.overviewPrintableProductsTemp['preroll'])];
				}
			}

			for (const product in this.overviewPrintableProductsTemp) {
				if (
					this.overviewPrintableProductsTemp[product].length == 1 &&
					(this.overviewPrintableProductsTemp[product][0].active ||
						this.overviewPrintableProductsTemp[product][0].disabled)
				) {
					this.overviewPrintableProducts['campaigns'][product] = this.overviewPrintableProductsTemp[product][0]
						.campaignName
						? this.overviewPrintableProductsTemp[product][0].campaignName
						: this.overviewPrintableProductsTemp[product][0].Name;
				} else if (this.overviewPrintableProductsTemp[product].length > 1) {
					if (this.overviewPrintableProductsTemp[product].some((product) => product.active)) {
						this.overviewPrintableProducts['campaigns'][product] =
							this.overviewPrintableProductsTemp[product].length + ' Campaigns';
					}
				}

				this.overviewPrintableProductsTemp[product].forEach((item, i) => {
					if (this.overviewPrintableProducts['advertisers'][product] == undefined) {
						this.overviewPrintableProducts['advertisers'][product] = new Array(
							this.overviewPrintableProductsTemp[product][i].adv_name
						);
					} else {
						this.overviewPrintableProducts['advertisers'][product].push(
							this.overviewPrintableProductsTemp[product][i].adv_name
						);
					}
				});
			}
		}
		for (const product in this.overviewPrintableProducts['advertisers']) {
			this.overviewPrintableProducts['advertisers'][product] = [
				...new Set(this.overviewPrintableProducts['advertisers'][product])
			];
			if (this.overviewPrintableProducts['advertisers'][product].length == 1) {
				this.overviewPrintableProducts['advertisers'][product] =
					this.overviewPrintableProducts['advertisers'][product][0];
			} else if (this.overviewPrintableProducts['advertisers'][product].length > 1) {
				this.overviewPrintableProducts['advertisers'][product] =
					this.overviewPrintableProducts['advertisers'][product].length + ' Advertisers';
			}
		}

		if (
			this.printableReportConfiguration?.coverPageEnabled != undefined &&
			this.analyticsDataModel.checkOverviewPrintablePermission(this.printableReportConfiguration.coverPageEnabled)
		) {
			this.overviewPrintableProducts['campaigns']['cover_page'] = 'Cover page';
		}

		for (const product in this.overviewPrintableProducts['campaigns']) {
			this.hasActiveCampaign = false;
			if (this.analyticsDataModel.checkOverviewPrintablePermission(this.overviewPrintablePermission[product])) {
				this.hasActiveCampaign = true;
				break;
			}
		}

		return filterBySelectedCampaign
			? campaignsByPermissions.filter((campaign: any) => {
					return _.findWhere(this.analyticsDataModel.selectedCampaigns, { id: campaign.campaignId });
			  })
			: campaignsByPermissions;
	}

	private activeAdvertiserFilter(advertisers, campaigns) {
		return advertisers.filter((advertiser: any) => {
			return _.findWhere(campaigns, { adv_name: advertiser.itemName });
		});
	}

	private campaignWithTwoPermissionFilteration(campaignPermission) {
		if (campaignPermission.includes('has_display_access') && campaignPermission.includes('has_geofence_access')) {
			return ['has_geofence_access'];
		} else if (
			campaignPermission.includes('has_display_access') &&
			campaignPermission.includes('has_geovideo_access')
		) {
			return ['has_geovideo_access'];
		} else if (
			campaignPermission.includes('has_preroll_access') &&
			campaignPermission.includes('has_geovideo_access')
		) {
			campaignPermission = ['has_geovideo_access'];
		} else {
			return campaignPermission;
		}
	}
}
